// export function mediaOrientation($thisitem, thismediawidth, thismediaheight) {
// // review - look at removing all jquery here.
//   console.log("mediaOrientation()");
//   console.log("$thisitem",$thisitem);
//   console.log("thismediawidth", thismediawidth);
//   console.log("thismediaheight", thismediaheight);
  
//     //item:
//     // if media item is Audio u need to change "thisitemto the place"
//     var $ = $ || jQuery;
//     var $this = $thisitem,
//       thiswidth = $this.width(),
//       thisheight = $this.height(),
//       thiswidthtoheightratio = (thiswidth / thisheight),
//       $thismedia = $this.find('img, video');
  
//      // console.log("$thismedia", $thismedia);
//      // $thismedia.css("background", "red");
  
//     if (thismediawidth == undefined) {
//       //  console.log("thismediawidth == undefined");
  
//       var thismediawidth = $thismedia.width(),
//         thismediaheight = $thismedia.height(),
//         thismediawidthtoheightratio = (thismediawidth / thismediaheight);
  
//       // console.log("thismediawidth",thismediawidth);
//       // console.log("thismediaheight",thismediaheight);
  
//     } else {
//       // console.log("ELSE: thismediawidth == undefined");
  
//       var thismediawidth = thismediawidth,
//         thismediaheight = thismediaheight,
//         thismediawidthtoheightratio = (thismediawidth / thismediaheight);
  
//       // console.log("thismediawidth",thismediawidth);
//       // console.log("thismediaheight",thismediaheight);
  
//     };
  
//     //  console.log("thismediawidthtoheightratio",thismediawidthtoheightratio);
  
//     $this.attr("item-ratio", ""); // remove existing value
//     $thismedia.attr("itemmedia-ratio", ""); // remove existing value
//     // set new value
//     $this.attr("item-ratio", thiswidthtoheightratio);
//     $thismedia.attr("itemmedia-ratio", thismediawidthtoheightratio);
  
//     // ensure any existing classes are removed fromt this item & image classes, as it might be duplicate
//     $this.removeClass("square-item image-larger-than-item vertical-item horizontal-item ratio-equal media-larger-than-item");
//     $thismedia.removeClass("square-media vertical-media horizontal-media");
  
  
//     if (thiswidth == thisheight) {
//       //width equals height = square item
  
//       $this.addClass("square-item");
  
//       if (thiswidthtoheightratio == thismediawidthtoheightratio) {
//         //  console.log("ratio equal")
  
//       } else if (thiswidthtoheightratio > thismediawidthtoheightratio) {
//         //the image is larger than th container it fits within:
//         // console.log("media-larger-than-item")
//         $this.addClass("media-larger-than-item");
  
//       } else if (thiswidthtoheightratio > thismediawidthtoheightratio) {

//         // console.log("thiswidthtoheightratio > thismediawidthtoheightratio")
//       } //height ratio
  
//     } else if (thiswidth < thisheight) {
//       //vertical item
  
  
//       //width smaller than height = vertical item
//       $this.addClass("vertical-item");
  
//       // console.log("thismediawidthtoheightratio"+thismediawidthtoheightratio+"")
//       if (thiswidthtoheightratio == thismediawidthtoheightratio) {
//         // console.log("ratio equal")
  
//       // } else if (thiswidthtoheightratio > thismediawidthtoheightratio) {
//                //altered the less/more symbol. I tink it was wrong? review
//       } else if (thiswidthtoheightratio < thismediawidthtoheightratio) {

//         //
//         // console.log("the image is larger than th container it fits within:")
  
//         $this.addClass("media-larger-than-item");
  
//       } else if (thiswidthtoheightratio > thismediawidthtoheightratio) {
  
//       } //height ratio
  
//     } else if (thiswidth > thisheight) {
//       //width larger than height = horizontal item
//       //  console.log("/width larger than height = horizontal item");

//       $this.addClass("horizontal-item");
//       // console.log("thiswidthtoheightratio"+thiswidthtoheightratio+"")
  
//       //console.log("thismediawidthtoheightratio"+thismediawidthtoheightratio+"")
//       if (thiswidthtoheightratio == thismediawidthtoheightratio) {
//       //  console.log("ratio equal");
//       // } else if (thiswidthtoheightratio > thismediawidthtoheightratio) {
//         //altered the less/more symbol. I tink it was wrong? review
//     } else if (thiswidthtoheightratio < thismediawidthtoheightratio) {

//         //the image is larger than th container it fits within:
//         // console.log("/the image is larger than th container it fits within:s");

//         $this.addClass("media-larger-than-item");
  
//       } else if (thiswidthtoheightratio > thismediawidthtoheightratio) {
//           // console.log("else thiswidthtoheightratio > thismediawidthtoheightratio ");

//       } //height ratio
  
//     } //itemratio
  
//     if (thismediawidth == thismediaheight) {
//       $thismedia.addClass("square-media");
//     } else if (thismediawidth < thismediaheight) {
//       $thismedia.addClass("vertical-media");
//     } else if (thismediawidth > thismediaheight) {
//       $thismedia.addClass("horizontal-media");
//     } ///image width vs height ratio
  
//   }; //  function mediaOrientation

// changed to js only:

export function mediaOrientation(thisitem, thismediawidth, thismediaheight) {
  console.log("mediaOrientation()");
  console.log("thisitem", thisitem);
  console.log("thismediawidth", thismediawidth);
  console.log("thismediaheight", thismediaheight);

  var thiswidth = thisitem.clientWidth,
      thisheight = thisitem.clientHeight,
      thiswidthtoheightratio = (thiswidth / thisheight),
      thismedia = thisitem.querySelector('img, video');

  if (thismediawidth === undefined) {
    thismediawidth = thismedia.clientWidth;
    thismediaheight = thismedia.clientHeight;
  }

  var thismediawidthtoheightratio = (thismediawidth / thismediaheight);

  thisitem.removeAttribute("item-ratio");
  thismedia.removeAttribute("itemmedia-ratio");

  thisitem.setAttribute("item-ratio", thiswidthtoheightratio);
  thismedia.setAttribute("itemmedia-ratio", thismediawidthtoheightratio);

  // Remove classes
  thisitem.classList.remove("square-item", "image-larger-than-item", "vertical-item", "horizontal-item", "ratio-equal", "media-larger-than-item");
  thismedia.classList.remove("square-media", "vertical-media", "horizontal-media");

  if (thiswidth == thisheight) {
    thisitem.classList.add("square-item");
    if (thiswidthtoheightratio > thismediawidthtoheightratio) {
      thisitem.classList.add("media-larger-than-item");
    }
  } else if (thiswidth < thisheight) {
    thisitem.classList.add("vertical-item");
    if (thiswidthtoheightratio < thismediawidthtoheightratio) {
      thisitem.classList.add("media-larger-than-item");
    }
  } else if (thiswidth > thisheight) {
    thisitem.classList.add("horizontal-item");
    if (thiswidthtoheightratio < thismediawidthtoheightratio) {
      thisitem.classList.add("media-larger-than-item");
    }
  }

  if (thismediawidth == thismediaheight) {
    thismedia.classList.add("square-media");
  } else if (thismediawidth < thismediaheight) {
    thismedia.classList.add("vertical-media");
  } else if (thismediawidth > thismediaheight) {
    thismedia.classList.add("horizontal-media");
  }
}
